import React, { useState } from "react";
import {
  ApartmentOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  DashboardOutlined,
  DesktopOutlined,
  ExperimentOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  TruckOutlined,
  ShopOutlined,
  UserSwitchOutlined,
  UsergroupAddOutlined,
  LogoutOutlined,
  GlobalOutlined,
  ReconciliationOutlined,
  FileDoneOutlined,
  ScanOutlined,
  EnvironmentOutlined,
  SolutionOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { Avatar, Layout, Menu, Modal, Button, theme, message, Drawer } from "antd";
import LOGO from "../../assets/fastest-logo.jpg.png";
import AdminProfile from "../adminProfile/AdminProfile";
import Dashboard from "../dashboard/Dashboard";
import Monitoring from "../monitoring/Monitoring";
import Order from "../orders/Orders";
import WellnessExecutive from "../wellnessExecutive/WellnessExecutive";
import Customer from "../customer/Customer";
import LabPartner from "../labPartner/LabPartner";
import Inventory from "../inventory/Inventory";
import Settings from "../settings/Settings";
import { logout } from "../../redux/slices/userSlice";
import { useDispatch, useSelector } from "react-redux";
import MasterData from "../masterData/MasterData";
import BMI from "../bmi/BMI";
import ReportTab from "../report/reporttabs/ReportTabs";
import WETracking from "../wellnessExecutive/WETracking";
import MIS from "../mis/MIS";
import QRCode from "../../pages/qrtrack/QRCode";
import WellnessExecutiveReport from "../wellnessExecutiveReport/WellnessExecutiveReport";
import CreateB2BClient from "../B2B/CreateB2BClientModal";
import B2BClientsList from "../B2B/B2BClientList";
import B2BClientServicePage from "../B2B/B2BClientServicePage";
import OrderList from "../orders/OrderList";
import GoogleMapsProvider from "../map/GoogleMapsProvider";

const { Sider, Content, Header } = Layout;

const Navigation = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [selectedMenuItem, setSelectedMenuItem] = useState("3");
  const [isLogoutModalVisible, setIsLogoutModalVisible] = useState(false);
  const [logoutActive, setLogoutActive] = useState(false);
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  const dispatch = useDispatch();

  const role = useSelector((state) => state?.user?.user?.role);

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const menuItems = [
    {
      key: "3",
      icon: <ShoppingCartOutlined className="!text-[16px]" />,
      label: "Orders",
      content: <OrderList />,
      roles: ["admin", "customer_care", "accounts"],
    },
    {
      key: "4",
      icon: <TruckOutlined className="!text-[16px]" />,
      label: "Wellness Executives",
      content: <WellnessExecutive />,
      roles: ["admin", "customer_care"],
    },
    {
      key: "5",
      icon: <SolutionOutlined className="!text-[16px]" />,
      label: "WE Check in/Out Report",
      content: <WellnessExecutiveReport />,
      roles: ["admin", "accounts", "customer_care"],
    },
    {
      key: "6",
      icon: <UsergroupAddOutlined className="!text-[16px]" />,
      label: "Customer",
      content: <Customer />,
      roles: ["admin", "customer_care", "accounts"],
    },
    {
      key: "7",
      icon: <UserOutlined className="!text-[16px]" />,
      label: "Users",
      content: <AdminProfile />,
      roles: ["admin", "accounts"],
    },
    {
      key: "8",
      icon: <UserSwitchOutlined className="!text-[16px]" />,
      label: "B2B",
      content: <B2BClientsList />,
      roles: ["admin", "accounts"],
    },
    {
      key: "9",
      icon: <ApartmentOutlined className="!text-[16px]" />,
      label: "B2B Directory of services",
      content: <B2BClientServicePage />,
      roles: ["admin", "accounts"],
    },
    {
      key: "10",
      icon: <ExperimentOutlined className="!text-[16px]" />,
      label: "Lab Partner",
      content: <LabPartner />,
      roles: ["admin", "accounts"],
    },
    {
      key: "11",
      icon: <GlobalOutlined className="!text-[16px]" />,
      label: "Master Data",
      content: <MasterData />,
      roles: ["admin", "accounts"],
    },
    {
      key: "12",
      icon: <ReconciliationOutlined className="!text-[16px]" />,
      label: "BMI",
      content: <BMI />,
      roles: ["admin", "accounts"],
    },
    {
      key: "13",
      icon: <FileDoneOutlined className="!text-[16px]" />,
      label: "Report",
      content: <ReportTab />,
      roles: ["admin", "accounts", "customer_care"],
    },
    {
      key: "14",
      icon: <EnvironmentOutlined className="!text-[16px]" />,
      label: "WE Tracking",
      content: (
        <GoogleMapsProvider>
          <WETracking />
        </GoogleMapsProvider>
      ),
      roles: ["admin"],
    },
    {
      key: "15",
      icon: <ScanOutlined className="!text-[16px]" />,
      label: "QR Tracking",
      content: <QRCode />,
      roles: ["admin", "accounts"],
    },
    {
      key: "16",
      icon: <SolutionOutlined className="!text-[16px]" />,
      label: "MIS",
      content: <MIS />,
      roles: ["admin", "accounts"],
    },
    {
      key: "17",
      icon: <SolutionOutlined className="!text-[16px]" />,
      label: "Monitoring",
      content: <Monitoring />,
      roles: ["admin", "customer_care"],
    },
  ];

  const filteredMenuItems = menuItems.filter(
    (item) => !item.roles || item.roles.includes(role)
  );

  const currentContent = filteredMenuItems.find(
    (item) => item.key === selectedMenuItem
  )?.content;

  const handleLogout = () => {
    dispatch(logout());
    console.log("User logged out and Redux state cleared");
    setIsLogoutModalVisible(false);
    setLogoutActive(false);
    message.success("Logout Successful!");
  };

  const handleCancel = () => {
    setIsLogoutModalVisible(false);
    setLogoutActive(false);
  };

  const showLogoutModal = () => {
    setIsLogoutModalVisible(true);
    setLogoutActive(true);
  };

  const handleMenuClick = ({ key }) => {
    setSelectedMenuItem(key);
    setMobileDrawerOpen(false);
  };

  // forceExpanded ensures drawer always shows full logo (not collapsed size)
  const SidebarContent = ({ onLogout, forceExpanded = false }) => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        minHeight: "100vh",
      }}
    >
      {/* Logo */}
      <div
        style={{
          width: "100%",
          height: 56,
          color: "#FFFF",
          marginTop: "1rem",
          marginBottom: "0.5rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <Avatar
          shape="square"
          src={LOGO}
          style={{
            width: collapsed && !forceExpanded ? "40px" : "160px",
            height: "44px",
            transition: "width 0.2s",
          }}
        />
      </div>

      {/* Scrollable Menu */}
      <div style={{ flex: 1, overflowY: "auto", overflowX: "hidden" }}>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[selectedMenuItem]}
          onClick={handleMenuClick}
          items={filteredMenuItems.map(({ key, icon, label }) => ({
            key,
            icon,
            label,
          }))}
        />
      </div>

      {/* Logout Button */}
      <div
        style={{
          padding: "1rem",
          textAlign: "center",
          flexShrink: 0,
          borderTop: "1px solid rgba(255,255,255,0.08)",
        }}
      >
        <Button
          type={logoutActive ? "primary" : "default"}
          icon={<LogoutOutlined />}
          style={{ width: "100%" }}
          className={logoutActive ? "bg-red-500" : ""}
          onClick={onLogout}
        >
          {(!collapsed || forceExpanded) && "Logout"}
        </Button>
      </div>
    </div>
  );

  return (
    <Layout className="min-h-screen">
      {/* ── Desktop Sider (hidden on mobile via CSS) ── */}
      <Sider
        collapsed={collapsed}
        onCollapse={setCollapsed}
        collapsible
        trigger={null}
        breakpoint="lg"
        collapsedWidth={80}
        style={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          position: "sticky",
          top: 0,
          left: 0,
          height: "100vh",
          overflow: "hidden",
        }}
        className="hidden-mobile"
      >
        <SidebarContent onLogout={showLogoutModal} />
      </Sider>

      {/* ── Mobile Drawer ── */}
      <Drawer
        placement="left"
        open={mobileDrawerOpen}
        onClose={() => setMobileDrawerOpen(false)}
        width={230}
        bodyStyle={{ padding: 0, background: "#001529" }}
        headerStyle={{ display: "none" }}
        className="mobile-nav-drawer"
      >
        {/* forceExpanded so logo always full-size in drawer */}
        <SidebarContent onLogout={showLogoutModal} forceExpanded />
      </Drawer>

      {/* ── Main Layout ── */}
      <Layout style={{ minWidth: 0 }}>
        {/* Mobile Header */}
        {/* Mobile Header */}
        <Header
          style={{
            background: colorBgContainer,
            padding: "0 16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
            position: "sticky",
            top: 0,
            zIndex: 100,
          }}
          className="mobile-header"
        >
          <Button
            type="text"
            icon={<MenuUnfoldOutlined style={{ fontSize: 20 }} />}
            onClick={() => setMobileDrawerOpen(true)}
          />

          {/* Absolutely centered logo */}
          <Avatar
            shape="square"
            src={LOGO}
            style={{
              width: "120px",
              height: "36px",
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
            }}
          />
        </Header>

        {/* Desktop collapse toggle — floats on sidebar edge */}
        <Button
          type="primary"
          shape="circle"
          size="small"
          icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          onClick={() => setCollapsed(!collapsed)}
          className="desktop-sider-toggle"
          style={{
            position: "fixed",
            top: 18,
            left: collapsed ? 68 : 188,
            zIndex: 200,
            transition: "left 0.2s",
            boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
          }}
        />

        <Content
          style={{
            margin: "16px 12px",
            padding: "16px 12px",
            minHeight: "calc(100vh - 80px)",
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
            overflow: "auto",
          }}
        >
          {currentContent}
        </Content>
      </Layout>

      {/* Logout Modal */}
      <Modal
        title="Confirm Logout"
        open={isLogoutModalVisible}
        onOk={handleLogout}
        onCancel={handleCancel}
        okText="Yes"
        cancelText="Cancel"
        centered
        style={{ maxWidth: "95vw" }}
      >
        <p>Are you sure you want to logout?</p>
      </Modal>

      {/* Responsive styles */}
      <style>{`
        /* ── Desktop: show sider, hide mobile header ── */
        @media (min-width: 769px) {
          .mobile-header {
            display: none !important;
          }
          .mobile-nav-drawer {
            display: none !important;
          }
          .desktop-collapse-btn {
            display: none !important;
          }
        }

        /* ── Mobile: hide sider, show mobile header ── */
        @media (max-width: 768px) {
          .hidden-mobile {
            display: none !important;
          }
          .desktop-sider-toggle {
            display: none !important;
          }
          .mobile-header {
            display: flex !important;
          }
          .ant-layout-content {
            margin: 8px 4px !important;
            padding: 10px 8px !important;
          }
        }

        /* ── Tablet (769px–1024px): collapsed sider ── */
        @media (min-width: 769px) and (max-width: 1024px) {
          .desktop-sider-toggle {
            display: flex !important;
          }
        }

        @media (min-width: 1025px) {
          .desktop-sider-toggle {
            display: flex !important;
          }
        }

        /* Prevent horizontal scroll on small screens */
        .ant-layout {
          min-width: 0 !important;
        }
        .ant-layout-content {
          min-width: 0 !important;
          word-break: break-word;
        }

        /* ── Global responsive table fix ── */
        @media (max-width: 768px) {
          .ant-table-wrapper {
            overflow-x: auto !important;
          }
          .ant-modal {
            max-width: 95vw !important;
            margin: 8px auto !important;
          }
          .ant-modal-body {
            max-height: 75vh;
            overflow-y: auto;
          }
          .ant-tabs-nav-wrap {
            overflow-x: auto !important;
          }
          .ant-tabs-nav-list {
            flex-wrap: nowrap !important;
          }
          .ant-form-item-label {
            padding-bottom: 2px !important;
          }
        }
      `}</style>
    </Layout>
  );
};

export default Navigation;